// extracted by mini-css-extract-plugin
module.exports = {"checkContainer":"Checkbox_checkContainer__1goJG","check":"Checkbox_check__2dQ2e","labelCheck":"Checkbox_labelCheck__1bK6x"};